export default "__VITE_ASSET__BgnJNRjb__"